/**
 * Roles Catalog Mapper
 * Maps transport layer DTOs to domain models
 */

import type { LC_GetRolesCatalogOut, RoleCatalog } from './roles.types';


export const mapRolesCatalog = (out: LC_GetRolesCatalogOut): RoleCatalog[] => {
  if (!out) return [];
  return out.map((item) => ({
    id: item.rolId,
    description: item.rolName || '',
  }));
};
